import { ROUTES } from "../types/routes";

// 需要显示底部导航栏的路由列表
export const BOTTOM_NAV_ROUTES = [
  ROUTES.HOME,
  ROUTES.HOME_ALT,
  ROUTES.VIP,
  ROUTES.EVENT_CENTER,
  ROUTES.PROFILE,
  ROUTES.AGENT_CENTER,
  ROUTES.INVITE_FRIENDS,
  ROUTES.ACCOUNT_DETAILS,
] as const;

// 导航栏高度常量
const NAVBAR_HEIGHT = "2.8125rem"; // 45px TopBar
const BOTTOM_NAV_HEIGHT = "6.5rem"; // 56px BottomTabBar
const SHARE_APP_BAR_HEIGHT = "2.75rem"; // 44px
const DOWNLOAD_APP_BAR_HEIGHT = "3rem"; // 48px，与 DownloadAppBar.scss 的 --height-48 一致

/**
 * 计算首页顶部偏移量（ShareAppBar + DownloadAppBar）
 * @param shareAppBarVisible ShareAppBar 是否可见
 * @param downloadAppBarVisible DownloadAppBar 是否可见
 * @returns 顶部偏移量
 */
export const getHomePageTopOffset = (
  shareAppBarVisible: boolean,
  downloadAppBarVisible: boolean
): string => {
  if (shareAppBarVisible && downloadAppBarVisible) {
    return `calc(${SHARE_APP_BAR_HEIGHT} + ${DOWNLOAD_APP_BAR_HEIGHT})`;
  } else if (shareAppBarVisible) {
    return "0rem";
  } else if (downloadAppBarVisible) {
    return DOWNLOAD_APP_BAR_HEIGHT;
  } else {
    return "0rem";
  }
};

/**
 * 底部主导航对应的「根路由」：应用整页刷新后 location.state 会丢失，
 * 不能依赖 fromBottomNav；只要路径属于底部 Tab 即显示 Layout 与底栏。
 */
export const isBottomNavRoute = (location: { pathname: string }): boolean => {
  return BOTTOM_NAV_ROUTES.some(route => location.pathname === route);
};

export const getPageContentHeight = (
  pathname: string,
  hasNavBar: boolean = true
): string => {
  const hasBottomNav = isBottomNavRoute({ pathname });
  const navBarHeight = hasNavBar ? NAVBAR_HEIGHT : "0rem";
  const bottomNavHeight = hasBottomNav ? BOTTOM_NAV_HEIGHT : "0rem";

  if (!hasNavBar && !hasBottomNav) {
    return "100vh";
  }

  if (hasNavBar && hasBottomNav) {
    return `calc(100vh - ${navBarHeight} - ${bottomNavHeight})`;
  }

  if (hasNavBar) {
    return `calc(100vh - ${navBarHeight})`;
  }

  return `calc(100vh - ${bottomNavHeight})`;
};

/**
 * 更新页面导航栏高度的 CSS 变量
 * @param location 当前路由 location 对象
 * @param homePageTopOffset 首页顶部偏移量（可选，仅首页需要）
 */
export const updatePageLayoutHeight = (
  location: any,
  homePageTopOffset?: string
): void => {
  const root = document.documentElement;

  // 判断是否有底部导航栏
  const hasBottomNav = isBottomNavRoute(location);

  // 判断是否是首页
  const isHomePage =
    location.pathname === ROUTES.HOME || location.pathname === ROUTES.HOME_ALT;

  // 判断是否有顶部导航栏（首页、Account 页无统一 Top NavBar）
  const hasNavBar = !isHomePage && location.pathname !== ROUTES.PROFILE;

  // 动态设置 CSS 变量
  root.style.setProperty("--navbar-height", hasNavBar ? NAVBAR_HEIGHT : "0rem");

  root.style.setProperty(
    "--bottom-nav-height",
    hasBottomNav ? BOTTOM_NAV_HEIGHT : "0rem"
  );

  // 如果是首页，设置顶部偏移量
  if (isHomePage && homePageTopOffset !== undefined) {
    root.style.setProperty("--home-top-offset", homePageTopOffset);
  }
};
